export const PrivatePolicyData = {
  title: "Private Policy",
  sections: [
    {
      heading: "1. Information We Collect",
      content: [
        "We collect information from you in various ways, including when you visit our website, make a purchase, or use our repair services.",
        "The types of personal information we collect include:",
        [
          "Personal Identification Information: Name, email address, phone number, billing and shipping address, company name (if applicable).",
          "Account Information: Username, password, and other information necessary to set up an account on our site.",
          "Payment Information: Credit card details, PayPal information, or other payment methods you use during checkout.",
          "Device Information: Information about the device you are purchasing or sending for repair, including device type, model, and serial number.",
          "Technical Information: Your IP address, browser type, operating system, and browsing activity on our site (e.g., the pages you visit and how long you spend on them).",
          "Cookies and Tracking Data: We use cookies to improve your experience and collect data about your visit to personalize content and ads, as well as analyze our website traffic."
        ]
      ]
    },
    {
      heading: "2. How We Use Your Information",
      content: [
        "We may use the personal information we collect for the following purposes:",
        [
          "To process your orders and provide the products and repair services you request.",
          "To communicate with you regarding your order status, shipping updates, or any issues related to your repair services.",
          "To improve our products, including billing and payment options.",
          "To manage your account, including saved devices and your usage.",
          "To send you promotional offers, newsletters, and marketing communications if you’ve opted in.",
          "To respond to customer service requests and resolve disputes.",
          "To comply with legal obligations as required by law."
        ]
      ]
    },
    {
      heading: "3. How We Share Your Information",
      content: [
        "We do not sell your personal information to third parties. However, we may share your information with third parties in the following situations:",
        [
          "Service Providers: We may share your information with third-party vendors and service providers (e.g., shipping companies, payment processors, technicians) who help us deliver the products or services you requested.",
          "Business Transfers: In case of a merger, acquisition, or sale of assets, your information may be transferred as part of such transactions.",
          "Legal Compliance: We may disclose your information if required to do so by law, or in response to a legal request from authorities."
        ]
      ]
    },
    {
      heading: "4. Your Rights and Choices",
      content: [
        [
          "Access and Update: You can access, update, or delete your account information by logging into your account on our website.",
          "Marketing Communications: If you’ve opted in to receive marketing communications, you can opt out at any time by following the unsubscribe instructions found in each email.",
          "Cookies: You can choose to limit or block tracking cookies or alert you when cookies are being sent. However, disabling cookies may affect the functionality of our site."
        ]
      ]
    },
    {
      heading: "5. Changes to This Privacy Policy",
      content: [
        "We may update this policy from time to time to reflect changes in our practices or for other operational, legal, or regulatory reasons. When we do, we will post the updated policy on this page and revise the “Effective Date” at the top of the policy."
      ]
    }
  ]
};
